import React, { useState } from "react";
import { Box, Typography, Container } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ProductCard from "../ProductCard/ProductCard";

const rubikfont = { fontFamily: "Rubik, sans-serif" };
const FIRST = 8;

// Layout 5: "Curated". A centred ornamental heading, eight products, and a button to reveal the rest.
const Layout5 = ({ data }) => {
    const products = (data?.product_id || []).slice(0, 12);
    const navigate = useNavigate();
    const [more, setMore] = useState(false);
    const shown = more ? products : products.slice(0, FIRST);
    const viewAll = () => navigate(`/search?layoutId=${data._id}&title=${encodeURIComponent(data.title)}`);

    return (
        <Box sx={{ py: { xs: 2, md: 3.5 } }}>
            <Container maxWidth="xl">
                <Box sx={{ display: "flex", alignItems: "center", gap: { xs: 1.5, md: 3 }, mb: { xs: 2.5, md: 3.5 } }}>
                    <Box sx={{ flex: 1, height: "1px", background: "linear-gradient(90deg, transparent, #C8A054)" }} />
                    <Box sx={{ textAlign: "center", px: 1 }}>
                        <Typography sx={{ fontSize: "11px", fontWeight: 600, letterSpacing: "4px", color: "#C8A054", textTransform: "uppercase", mb: 0.5, ...rubikfont }}>
                            {data?.subtitle || "Exclusive Collection"}
                        </Typography>
                        <Typography sx={{ fontSize: { xs: "24px", sm: "34px" }, fontWeight: 800, color: "#111", fontFamily: "'Playfair Display', serif", lineHeight: 1.1 }}>
                            {data?.title}
                        </Typography>
                    </Box>
                    <Box sx={{ flex: 1, height: "1px", background: "linear-gradient(270deg, transparent, #C8A054)" }} />
                </Box>

                <Box
                    sx={{
                        display: "grid",
                        gridTemplateColumns: { xs: "repeat(2, minmax(0, 1fr))", sm: "repeat(3, minmax(0, 1fr))", lg: "repeat(4, minmax(0, 1fr))" },
                        gap: { xs: 1.25, md: 2.5 },
                    }}
                >
                    {shown.map((product) => (
                        <Box key={product._id}>
                            <ProductCard product={product} />
                        </Box>
                    ))}
                </Box>

                <Box sx={{ display: "flex", justifyContent: "center", gap: 1.5, mt: { xs: 2.5, md: 3.5 }, flexWrap: "wrap" }}>
                    {products.length > FIRST && (
                        <Box onClick={() => setMore((m) => !m)} sx={{ px: 3.5, py: 1, borderRadius: "999px", border: "1px solid #111", color: "#111", fontSize: "12px", fontWeight: 600, letterSpacing: "1.5px", textTransform: "uppercase", cursor: "pointer", transition: "all .2s", "&:hover": { bgcolor: "#111", color: "#fff" }, ...rubikfont }}>
                            {more ? "Show less" : `Show ${products.length - FIRST} more`}
                        </Box>
                    )}
                    <Box onClick={viewAll} sx={{ px: 3.5, py: 1, borderRadius: "999px", bgcolor: "#C8A054", color: "#fff", fontSize: "12px", fontWeight: 600, letterSpacing: "1.5px", textTransform: "uppercase", cursor: "pointer", transition: "all .2s", "&:hover": { bgcolor: "#a8832f" }, ...rubikfont }}>
                        View all
                    </Box>
                </Box>
            </Container>
        </Box>
    );
};

export default Layout5;
